export default __webpack_public_path__ + "static/media/comment-red.49899d39.svg";